import React from 'react';

export default function ColGroup({ columnInfo }) {
    let { leaf: { columns, columnsWidth } } = columnInfo;
    return <colgroup>
        {columns.map(({ key, width, visible = true }, index) => {
            if (!visible) {
                return null;
            }
            return <col key={key} style={{ width: columnsWidth[index] || width }} />;
        })}
    </colgroup>;
}